import { Nil } from "./types";

function noop() {
  return null;
}

function identity<T>(arg: T): T {
  return arg;
}

function hasKey(obj: any, key: string) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function ifElse<T, R>(
  cond: (val: T) => boolean,
  ifFn: (val: T) => R,
  elseFn: (val: T) => R,
  val: T
) {
  if (cond(val)) {
    return ifFn(val);
  }
  return elseFn(val);
}

function always<T>(val: T) {
  return () => val;
}

/**
 * a more typesafe version of (arr || [])[0] if arr can be undefined because the returning type will be
 * type | null, not type.
 * @param arr
 */
export function firstOrUndefined<T>(arr: ArrayLike<T> | Nil): T | undefined {
  const obj = (arr || [])[0];
  return obj == null ? undefined : obj;
}

/**
 * Functional functions
 */
export const fns = {
  firstOrUndefined,
  noop,
  identity,
  hasKey,
  ifElse,
  always,
  sum<T>(fn: (arg: T) => number, data: T[]) {
    return data.reduce((prev, curr) => prev + fn(curr), 0);
  },
};
